import { render, staticRenderFns } from "./newsItem.vue?vue&type=template&id=1983bcee&"
import script from "./newsItem.vue?vue&type=script&lang=js&"
export * from "./newsItem.vue?vue&type=script&lang=js&"
import style0 from "./newsItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports